import { inject, Injectable } from '@angular/core';
import { TranslateStore } from '@ngx-translate/core';
import { LanguageService } from '../app/language.service';

/**
 * ngx-translate v17 removed TranslateParser.getValue(), so key resolution can no longer be
 * customised through the parser - it now happens in TranslateStore.getValue().
 *
 * Translations are loaded (see TranslatePoLoader) as { [msgctxt]: { [msgid]: msgstr } }, where the
 * empty msgctxt ('') holds the default terminology. This store resolves a key against the current
 * terminology (programIdentifier) msgctxt first, then falls back to the default context, then lets
 * ngx-translate fall back to the key itself. Doing a direct (non dotted) lookup also means msgids
 * that contain '.' are matched correctly.
 */
@Injectable()
export class MiradiTranslateStore extends TranslateStore {

  private languageService = inject(LanguageService);

  protected override getValue(language: string, key: string): any {
    const translations: any = this.getTranslations(language);
    if (!translations) {
      return undefined;
    }

    const context = this.languageService.currentTerminology?.programIdentifier;
    if (context && translations[context] && translations[context][key] !== undefined) {
      return translations[context][key];
    }

    return translations['']?.[key];
  }

}
